import { render } from "./SlotReport.vue?vue&type=template&id=65be15e4"
import script from "./SlotReport.vue?vue&type=script&lang=js"
export * from "./SlotReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__